import { APP_PDC_URL } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const answersConstants = {
  SAVE_ANSWER_ASK_ERROR: "SAVE_ANSWER_ASK_ERROR",
  SAVE_ANSWER_ASK_START: "SAVE_ANSWER_ASK_START",
  SAVE_ANSWER_ASK_SUCCESS: "SAVE_ANSWER_ASK_SUCCESS",

  SEND_ANSWER_ASK_ERROR: "SEND_ANSWER_ASK_ERROR",
  SEND_ANSWER_ASK_START: "SEND_ANSWER_ASK_START",
  SEND_ANSWER_ASK_SUCCESS: "SEND_ANSWER_ASK_SUCCESS",

  CREATE_SEND_ANSWER_ASK_ERROR: "CREATE_SEND_ANSWER_ASK_ERROR",
  CREATE_SEND_ANSWER_ASK_START: "CREATE_SEND_ANSWER_ASK_START",
  CREATE_SEND_ANSWER_ASK_SUCCESS: "CREATE_SEND_ANSWER_ASK_SUCCESS",

  CHANGE_ANSWER_READ_START: "CHANGE_ANSWER_READ_START",
  CHANGE_ANSWER_READ_SUCCESS: "CHANGE_ANSWER_READ_SUCCESS",
  CHANGE_ANSWER_READ_ERROR: "CHANGE_ANSWER_READ_ERROR",

  MOVE_ANSWER_DOCUMENT_START: "MOVE_ANSWER_DOCUMENT_START",
  MOVE_ANSWER_DOCUMENT_SUCCESS: "MOVE_ANSWER_DOCUMENT_SUCCESS",
  MOVE_ANSWER_DOCUMENT_ERROR: "MOVE_ANSWER_DOCUMENT_ERROR",

  GET_ANSWER_DOCUMENT_DETAIL_START: "GET_ANSWER_DOCUMENT_DETAIL_START",
  GET_ANSWER_DOCUMENT_DETAIL_SUCCESS: "GET_ANSWER_DOCUMENT_DETAIL_SUCCESS",
  GET_ANSWER_DOCUMENT_DETAIL_ERROR: "GET_ANSWER_DOCUMENT_DETAIL_ERROR",

  GET_ANSWER_DOCUMENT_PREVIEW_START: "GET_ANSWER_DOCUMENT_PREVIEW_START",
  GET_ANSWER_DOCUMENT_PREVIEW_SUCCESS: "GET_ANSWER_DOCUMENT_PREVIEW_SUCCESS",
  GET_ANSWER_DOCUMENT_PREVIEW_ERROR: "GET_ANSWER_DOCUMENT_PREVIEW_ERROR",

  CLEAR_ANSWER_ATTACHMENT: "CLEAR_ANSWER_ATTACHMENT"
};

export function saveSurveyAsk(answerId,
  items) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected =  getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }

    return new Promise((resolve, reject) => {
      let request = {
        method: "PUT",
        url: APP_PDC_URL + "/api/v1/answers/" + answerId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {
          itemId: companyUuidSelected,
          isCompleted: false,
          items: items
        }
      };

      dispatch({
        type: answersConstants.SAVE_ANSWER_ASK_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: answersConstants.SAVE_ANSWER_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: answersConstants.SAVE_ANSWER_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: answersConstants.SAVE_ANSWER_ASK_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function sendSurveyAsk(answerId,
  items) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }

    return new Promise((resolve, reject) => {
      let request = {
        method: "PUT",
        url: APP_PDC_URL + "/api/v1/answers/" + answerId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {
          itemId: companyUuidSelected,
          isCompleted: true,
          items: items
        }
      };

      dispatch({
        type: answersConstants.SEND_ANSWER_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: answersConstants.SEND_ANSWER_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: answersConstants.SEND_ANSWER_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: answersConstants.SEND_ANSWER_ASK_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function changeAnswerRead(answerId,
  isViewed) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url:
          APP_PDC_URL + "/api/v1/answers/" + answerId + "/viewed",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {
          itemId: companyUuidSelected,
          isViewed: isViewed
        }
      };

      dispatch({
        type: answersConstants.CHANGE_ANSWER_READ_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: answersConstants.CHANGE_ANSWER_READ_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: answersConstants.CHANGE_ANSWER_READ_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: answersConstants.CHANGE_ANSWER_READ_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function createAndSendAnswerAsk(templateId,
  items) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;
    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: APP_PDC_URL + "/api/v1/answers",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {
          templateId: templateId,
          itemId: companyUuidSelected,
          managerId: accountantUuidSelected,
          isCompleted: true,
          items: items
        }
      };

      dispatch({
        type: answersConstants.CREATE_SEND_ANSWER_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: answersConstants.CREATE_SEND_ANSWER_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: answersConstants.CREATE_SEND_ANSWER_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: answersConstants.CREATE_SEND_ANSWER_ASK_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function moveAnswerFile(
  answerId,
  documentId,
  documentOwner
) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const accountantSelected = getState().main.accountantSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url:
          APP_PDC_URL +
          "/api/v1/answers/" +
          answerId +
          "/documents/" +
          documentId +
          "/move",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: {
          destination: "dbox",
          recipientId: documentOwner.codiceFiscale,
          senderId: accountantSelected,
          partitaIva: documentOwner.partitaIva,
          codiceFiscale: documentOwner.codiceFiscale
        }
      };

      dispatch({
        type: answersConstants.MOVE_ANSWER_DOCUMENT_START,
        payload: { id: documentId }
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: answersConstants.MOVE_ANSWER_DOCUMENT_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: answersConstants.MOVE_ANSWER_DOCUMENT_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: answersConstants.MOVE_ANSWER_DOCUMENT_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function getAnswerDocumentDetail(answerId,
  documentId) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;

    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected =  main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url:
          APP_PDC_URL +
          "/api/v1/answers/" +
          answerId +
          "/documents/" +
          documentId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: answersConstants.GET_ANSWER_DOCUMENT_DETAIL_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: answersConstants.GET_ANSWER_DOCUMENT_DETAIL_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: answersConstants.GET_ANSWER_DOCUMENT_DETAIL_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: answersConstants.GET_ANSWER_DOCUMENT_DETAIL_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function getAnswerDocumentPreview(answerId,
  documentId) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;

    const accountantUuidSelected= main.accountantUuidSelected;
    const companyUuidSelected= main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url:
          APP_PDC_URL +
          "/api/v1/answers/" +
          answerId +
          "/previews/" +
          documentId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: answersConstants.GET_ANSWER_DOCUMENT_PREVIEW_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: answersConstants.GET_ANSWER_DOCUMENT_PREVIEW_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: answersConstants.GET_ANSWER_DOCUMENT_PREVIEW_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: answersConstants.GET_ANSWER_DOCUMENT_PREVIEW_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}
